import { ThemeTable } from "../themes/table";

onload(() => {
  const navbar = document.querySelector('nav.search-navbar')
  const input = navbar?.querySelector('input[name="search"]')
  const table = new ThemeTable({
    type: 'search'
  });
  // table.search()

  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      table.search(input.value)
    }
  })
  navbar?.querySelector('button')?.addEventListener('click', (e) => {
    table.search(input?.value || '')
  })
});